import { BotaoVoltar } from "@/components/BotaoVoltar";
import { setSessionItem, removeSessionItem } from "@/lib/storage-safe";

const CHAVE = "origem-inicio";

/** Marca que a navegação partiu da tela Inicial. */
export function marcarOrigemInicio() {
  try {
    setSessionItem(CHAVE, "1");
  } catch {
    /* ignora */
  }
}

/** Botão "Voltar para Início"; em janela popup, apenas fecha a janela. */
export function VoltarInicio({ icone = true }: { icone?: boolean }) {
  const limpar = () => {
    try {
      removeSessionItem(CHAVE);
    } catch {
      /* ignora */
    }
  };

  return <BotaoVoltar destino="/inicio" rotulo="Início" icone={icone} aoAcionar={limpar} />;
}
